import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

const faroConfigByEnvironment = {
  staging: {
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/65966d9eb3d696eec9b5905580ecf4f2',
    samplingRate: 0.2,
  },
  production: {
    url: 'https://faro-collector-prod-eu-west-2.grafana.net/collect/aab17b03d3a36b9be243151c4ba0c384',
    samplingRate: 0.05,
  },
};

export const initializeRum = (environment) => {
  const config = faroConfigByEnvironment[environment];

  if (!config) {
    return;
  }

  const { url, samplingRate } = config;

  initializeFaro({
    url,
    app: {
      name: 'ECP',
      version: '1.0.0',
      environment,
    },
    sessionTracking: {
      samplingRate,
    },
    instrumentations: [
      ...getWebInstrumentations(),
      new TracingInstrumentation(),
    ],
  });
};
